/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Logistics_Dashboard_DescriptionInputs */

const en_logistics_dashboard_description = /** @type {(inputs: Logistics_Dashboard_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Order fulfillment overview and pipeline tracking`)
};

const es_logistics_dashboard_description = /** @type {(inputs: Logistics_Dashboard_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resumen de cumplimiento y seguimiento del flujo de pedidos`)
};

/**
* | output |
* | --- |
* | "Order fulfillment overview and pipeline tracking" |
*
* @param {Logistics_Dashboard_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const logistics_dashboard_description = /** @type {((inputs?: Logistics_Dashboard_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Logistics_Dashboard_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_logistics_dashboard_description(inputs)
	return es_logistics_dashboard_description(inputs)
});